import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: '26495c23-5f23-4e07-a781-8f553efaa8f2',
    countryCodes: ['CZ'],
    locale: 'cs-CZ',
});
